declare let process: unknown;

export const loadFonts = async () => {
  const mod =
    typeof process === "undefined"
      ? await import("./fonts.browser")
      : await import("./fonts.node");

  return mod.fonts;
};
